import { storage } from 'app/utils/storage';

export const loadMessages = async (version: string | null) => {
  try {
    const response = await fetch(
      `https://app.procure.co/constant/messages/web/messages?version=${version}`,
    );
    const messages = await response.json();
    storage.set('messages', JSON.stringify(messages));
  } catch (error) {
    console.log('Failed to load messages');
  } finally {
  }
};

export const checkVersion = async () => {
  try {
    const response = await fetch('https://app.procure.co/constant/messages/web/version');
    const { version } = await response.json();
    const _version = storage.get('version');

    if (version !== _version) {
      storage.set('messageVersion', version);
      await loadMessages(_version);
    }
  } catch (error) {
    console.log('Failed to check message version');
  }
};